import { render, staticRenderFns } from "./metodologia.vue?vue&type=template&id=370da620"
import script from "./metodologia.vue?vue&type=script&lang=js"
export * from "./metodologia.vue?vue&type=script&lang=js"
import style0 from "./metodologia.vue?vue&type=style&index=0&id=370da620&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports